export default __webpack_public_path__ + "static/media/contact-hero.f35dee0c.png";